import { faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useEffect, useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import PopupContext from '../../../store/popup-context';

function FileInput(props) {
  const {
    label: initialLabel = 'Datei hinzufügen',
    types = [],
    handleChange,
    multiple = false,
    className,
  } = props;

  const { setPopupMessage } = useContext(PopupContext);
  const [label, setLabel] = useState(initialLabel);

  useEffect(() => {
    if (initialLabel) setLabel(initialLabel);
  }, [initialLabel]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;

      const oversized = acceptedFiles.some((file) => file.size > 1024 * 1024);
      if (oversized) {
        setPopupMessage('Datei zu groß. Max 1 Megabyte.', 'error');
        return;
      }

      if (multiple) {
        handleChange(acceptedFiles);
        setLabel(`${acceptedFiles.length} Dateien ausgewählt`);
      } else {
        handleChange(acceptedFiles[0]);
        setLabel(acceptedFiles[0].name);
      }
    },
    [handleChange, multiple, setPopupMessage]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: types.map((type) => `.${type.toLowerCase()}`),
    maxFiles: multiple ? undefined : 1,
    multiple,
  });

  return (
    <div
      {...getRootProps()}
      className={`noSelect flex justify-between items-center px-2.5 w-full h-[58px] text-sm text-gray-900 bg-transparent rounded border-[1px] border-gray-300 appearance-none peer focus:border-[var(--text-color)] focus:outline-none ${
        isDragActive ? 'border-primary bg-gray-50' : ''
      } ${className || ''}`}
      style={{ cursor: 'pointer' }}
    >
      <input {...getInputProps()} />
      <FontAwesomeIcon icon={faFile} className="ml-2 text-gray-500" />
      <span className="ml-3 text-left truncate">{label}</span>
      <span className="mr-3 ml-auto text-[12px] text-right text-gray-500">
        {types.join(', ')}
      </span>
    </div>
  );
}

export default FileInput;
